import { COMPANY } from "../../data/products";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-zinc-950 text-zinc-400 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pb-12 border-b border-zinc-800">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-5 inline-block bg-white p-2.5">
              <img
                src="/budobet-logo-sm.png"
                alt="BUDOBET.PL"
                className="h-10 w-auto object-contain block"
              />
            </div>
            <p className="text-sm leading-relaxed max-w-md">
              Hurtowa i detaliczna sprzedaż wełny mineralnej szklanej w najlepszych
              cenach w Polsce. Klasa A1, certyfikaty, sprawdzona przez tysiące
              wykonawców. <strong className="text-white">Darmowa dostawa od 4 palet</strong> na
              terenie całego kraju.
            </p>
            <div className="mt-6 flex items-center gap-2">
              <span className="bg-red-600 text-white font-tech text-[10px] uppercase tracking-widest font-bold px-2.5 py-1">
                Klasa A1
              </span>
              <span className="bg-zinc-800 text-zinc-300 font-tech text-[10px] uppercase tracking-widest font-bold px-2.5 py-1">
                EUCEB
              </span>
              <span className="bg-zinc-800 text-zinc-300 font-tech text-[10px] uppercase tracking-widest font-bold px-2.5 py-1">
                EN 13162
              </span>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-display text-white text-sm uppercase tracking-widest mb-5">
              Nawigacja
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#produkty" className="hover:text-red-500 transition">
                  Produkty
                </a>
              </li>
              <li>
                <a href="#porownanie" className="hover:text-red-500 transition">
                  Porównanie
                </a>
              </li>
              <li>
                <a href="#kalkulator" className="hover:text-red-500 transition">
                  Kalkulator
                </a>
              </li>
              <li>
                <a href="#zastosowanie" className="hover:text-red-500 transition">
                  Zastosowanie
                </a>
              </li>
              <li>
                <a href="#pobierz" className="hover:text-red-500 transition">
                  Pliki do pobrania
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-white text-sm uppercase tracking-widest mb-5">
              Kontakt
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a
                  href={`tel:${COMPANY.phone.replace(/\s/g, "")}`}
                  className="hover:text-red-500 transition"
                >
                  {COMPANY.phone}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="hover:text-red-500 transition"
                >
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 pt-8 text-xs">
          <span className="font-tech uppercase tracking-widest text-zinc-500">
            © {new Date().getFullYear()} BUDOBET.PL — Wszystkie prawa zastrzeżone.
          </span>
          <div className="flex gap-6 font-tech uppercase tracking-widest text-zinc-500">
            <a href="#" className="hover:text-red-500 transition">
              Polityka prywatności
            </a>
            <a href="#" className="hover:text-red-500 transition">
              Regulamin
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
